import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  boardComponentItem:[],
  boardComponentError: '',
  boardComponentLoading: false,
  boardComponentsError: '',
  boardComponentsLoading: false,
  boardComponentTypesList:[],
  boardComponentTypesError: '',
  boardComponentTypesLoading: false
}

const getters = {
  boardComponentLoading: state => state.boardComponentLoading,
  boardComponentError: state => state.boardComponentError,
  boardComponentItem: state => state.boardComponentItem,
  boardComponentsLoading: state => state.boardComponentsLoading,
  boardComponentsError: state => state.boardComponentsError,
  boardComponentTypesLoading: state => state.boardComponentTypesLoading,
  boardComponentTypesError: state => state.boardComponentTypesError,
  boardComponentTypesList: state => state.boardComponentTypesList
}

const mutations = {
  [types.GET_BOARD_COMPONENT_REQUEST] (state){
    state.boardComponentLoading = true;
    state.boardComponentItem = {};
    state.boardComponentError = {};
  },
  [types.GET_BOARD_COMPONENT_SUCCESS] (state, boardComponent){
    state.boardComponentLoading = false;
    state.boardComponentItem = boardComponent;
    state.boardComponentError = {};
  },
  [types.GET_BOARD_COMPONENT_FAILURE] (state, error){
    state.boardComponentLoading = false;
    state.boardComponentItem = {};
    state.boardComponentError = error;
  },
  [types.GET_BOARD_COMPONENT_TYPES_REQUEST] (state){
    state.boardComponentTypesLoading = true;
    state.boardComponentTypesList = [];
    state.boardComponentTypesError = {};
  },
  [types.GET_BOARD_COMPONENT_TYPES_SUCCESS] (state, boardComponentTypes){
    state.boardComponentTypesLoading = false;
    state.boardComponentTypesList = boardComponentTypes;
    state.boardComponentTypesError = {};
  },
  [types.GET_BOARD_COMPONENT_TYPES_FAILURE] (state, error){
    state.boardComponentTypesLoading = false;
    state.boardComponentTypesList = [];
    state.boardComponentTypesError = error;
  },
  [types.ADD_BOARD_COMPONENT_REQUEST](state){
    state.boardComponentsLoading = true;
    state.boardComponentsError = {};
  },
  [types.ADD_BOARD_COMPONENT_SUCCESS](state, boardComponent){
    state.boardComponentsLoading = true;
    state.boardComponentsError = {};
  },
  [types.ADD_BOARD_COMPONENT_FAILURE](state, error){
    state.boardComponentsLoading = false;
    state.boardComponentsError = error;
  },
  [types.UPDATE_BOARD_COMPONENT_REQUEST](state){
    state.boardComponentsLoading = true;
    state.boardComponentsError = {};
  },
  [types.UPDATE_BOARD_COMPONENT_SUCCESS](state, boardComponent){
    state.boardComponentsLoading = true;
    state.boardComponentsError = {};
  },
  [types.UPDATE_BOARD_COMPONENT_FAILURE](state, error){
    state.boardComponentsLoading = false;
    state.boardComponentsError = error;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
